import React from 'react';
import PropTypes from 'prop-types';
import StandstillExtraElement from './StandstillExtraElement';

import { STANDSTILL_FIELD } from 'modules/shipper-order/Form/constants';

import { StyledExtraContainer } from '../styled';
import styled from 'styled-components';

const StyledStandStillElement = styled(StandstillExtraElement)`
  border-bottom: 1px solid var(--greyWolf);
`;

const StandstillExtra = ({ stops, quote, ...props }) => {
  const { standstills = [] } = quote;
  return (
    <StyledExtraContainer>
      {(stops || []).map((stop, key) => (
        <StyledStandStillElement
          key={key}
          stop={stop}
          name={[STANDSTILL_FIELD, key]}
          stop_id={key}
          shipment_id={(Object.keys(stop.shipments) || [])[0]}
          pricePerHour={
            quote.ready && !quote.loading
              ? (standstills.find(({ stop_id }) => stop_id === key) || {}).price_hour
              : undefined
          }
          {...props}
        />
      ))}
    </StyledExtraContainer>
  );
};

StandstillExtra.propTypes = {
  stops: PropTypes.array.isRequired,
  quote: PropTypes.object.isRequired,
};

StandstillExtra.defaultProps = {
  stops: [],
};

export default StandstillExtra;
